import PropTypes from "prop-types";

const VIEWPORT_BREAKPOINT = 768;
const OFFSET_TOP = 50;
const EXIT_INTENT_COOKIE_NAME = "_ei";
const EMAIL_COOKIE_NAME = "_ea";
const SUBMIT_SERVICE = "https://sunwing.tfaforms.net/api_v2/workflow/processor";
const INLINE_VARIANT = "inline";
const SPLIT_VARIANT = "split";
const MODAL_VARIANT = "modal";
const COOKIE_BANNER_TIMEOUT = 100;
const MOBILE_MENU_THRESHOLD = 40;
const MARGIN_BOTTOM_HIDE = -100;
const EMAIL_CHAR_LIMIT = 254;

// Registration states
const REGISTRATION_STATE_SAVED_CLOSED = "1"; // User completed signup and closed widget
const REGISTRATION_STATE_SAVED = "2"; // User completed signup (widget may still be open)
const REGISTRATION_STATE_INIT = null; // Initial state before signup
const REGISTRATION_KEY_FALLBACK = "ea-registration-sign-up";
const getRegistrationKey = contentfulId =>
	contentfulId ? `ea-registration-${contentfulId}` : REGISTRATION_KEY_FALLBACK;
const FORM_ASSEMBLY_FIELDS = {
	en: {
		email: {
			id: "tfa_12",
			value: "",
		},
		campaign_code: {
			id: "tfa_24",
			value: "",
		},
		preferred_gateways_code: {
			id: "tfa_25",
			value: "",
		},
		preferred_gateways_name: {
			id: "tfa_22",
			value: "",
		},
		user_id: {
			id: "tfa_26",
			value: "",
		},
		anonymous_id: {
			id: "tfa_27",
			value: "",
		},
	},
	fr: {
		email: {
			id: "tfa_12",
			value: "",
		},
		campaign_code: {
			id: "tfa_24",
			value: "",
		},
		preferred_gateways_code: {
			id: "tfa_25",
			value: "",
		},
		preferred_gateways_name: {
			id: "tfa_22",
			value: "",
		},
		user_id: {
			id: "tfa_26",
			value: "",
		},
		anonymous_id: {
			id: "tfa_27",
			value: "",
		},
	},
};

const FORM_ASSEMBLY_ENVIRONMENT = {
	development: {
		en: {
			tfa_dbFormId: "135",
			tfa_dbControl: "9ded52b5c2a8c325ef6714108ed1f262",
			tfa_dbVersionId: "2",
			tfa_dbResponseId: "",
		},
		fr: {
			tfa_dbFormId: "153",
			tfa_dbControl: "a808197f9178d985a2dd8dad8d0f93d3",
			tfa_dbVersionId: "2",
			tfa_dbResponseId: "",
		},
	},
	production: {
		en: {
			tfa_dbFormId: "103",
			tfa_dbControl: "c1d2c920162e13cb1102958ab8823248",
			tfa_dbVersionId: "4",
			tfa_dbResponseId: "",
		},
		fr: {
			tfa_dbFormId: "104",
			tfa_dbControl: "ed31980488d1486d4ab0258810d36b71",
			tfa_dbVersionId: "3",
			tfa_dbResponseId: "",
		},
	},
};

const CONFIG_PROPTYPE = PropTypes.shape({
	contentful_id: PropTypes.string.isRequired,
	environment: PropTypes.string,
	sys: PropTypes.shape({
		contentType: PropTypes.shape({
			sys: PropTypes.shape({
				id: PropTypes.string.isRequired,
			}).isRequired,
		}).isRequired,
	}).isRequired,
	variant: PropTypes.string,

	// Default variant data
	modalHeading: PropTypes.string,
	modalSubHeading: PropTypes.string,
	modalImage: PropTypes.arrayOf(PropTypes.shape({ secure_url: PropTypes.string })),
	modalCampaignId: PropTypes.string,

	// Inline variant data
	inlineHeading: PropTypes.string,
	inlineSubHeading: PropTypes.string,
	inlineImage: PropTypes.arrayOf(PropTypes.shape({ secure_url: PropTypes.string })),
	inlineCampaignId: PropTypes.string,

	// Split variant data
	splitHeading: PropTypes.string,
	splitSubHeading: PropTypes.string,
	splitCampaignId: PropTypes.string,

	// Exit intent variant data
	exitHeading: PropTypes.string,
	exitSubHeading: PropTypes.string,
	exitImage: PropTypes.arrayOf(PropTypes.shape({ secure_url: PropTypes.string })),
	exitCampaignId: PropTypes.string,
	exitExpiry: PropTypes.number,
});

const MODE_OPTIONS = ["desktop", "mobile"];

export {
	VIEWPORT_BREAKPOINT,
	OFFSET_TOP,
	EXIT_INTENT_COOKIE_NAME,
	EMAIL_COOKIE_NAME,
	INLINE_VARIANT,
	SPLIT_VARIANT,
	MODAL_VARIANT,
	REGISTRATION_STATE_SAVED_CLOSED,
	REGISTRATION_STATE_SAVED,
	REGISTRATION_STATE_INIT,
	FORM_ASSEMBLY_FIELDS,
	SUBMIT_SERVICE,
	FORM_ASSEMBLY_ENVIRONMENT,
	CONFIG_PROPTYPE,
	COOKIE_BANNER_TIMEOUT,
	MODE_OPTIONS,
	MOBILE_MENU_THRESHOLD,
	MARGIN_BOTTOM_HIDE,
	EMAIL_CHAR_LIMIT,
	getRegistrationKey,
};
